import React, { FunctionComponent } from 'react';
import {
  Avatar,
  AvatarProps,
  Card,
  CardContent,
  CardContentProps,
  CardProps,
  Stack,
  SxProps,
  Typography,
  TypographyProps,
} from '@mui/material';

interface ShortUserCardProps {
  short?: boolean;
  firstName: string;
  lastName?: string;
  avatar?: string;
  cardProps?: CardProps;
  cardContentProps?: CardContentProps;
  avatartprops?: AvatarProps;
  nameProps?: TypographyProps;
}

const defaultAvatarStyles: SxProps = {
  width: '24px',
  height: '24px',
};

const ShortUserCard: FunctionComponent<ShortUserCardProps> = ({
  short = false,
  firstName,
  lastName,
  avatar = undefined,
  cardProps = {},
  cardContentProps = {},
  avatartprops = {},
  nameProps = {},
}) => {
  let name = firstName;

  if (lastName) {
    if (short) {
      name += ` ${lastName.substring(0, 1)}.`;
    } else {
      name += ` ${lastName}`;
    }
  }

  return (
    <Card
      elevation={0}
      {...cardProps}
      sx={{
        borderRadius: '10px',
        width: 'fit-content',
        ...(cardProps.sx || {}),
      }}
    >
      <CardContent
        {...cardContentProps}
        style={{ padding: 0, ...(cardContentProps.style || {}) }}
      >
        <Stack direction="row" alignItems="center" columnGap="10px">
          <Avatar
            src={avatar}
            {...avatartprops}
            sx={{ ...defaultAvatarStyles, ...(avatartprops.sx || {}) }}
          />
          <Typography
            variant="subtitle2"
            fontSize="16px"
            className="ellipsis-text"
            fontWeight={500}
            maxWidth="150px"
            color="#94A3B8"
            {...nameProps}
          >
            {name}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ShortUserCard;
